import { useEffect, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { FaChevronRight } from "react-icons/fa";
import { MdHomeFilled } from "react-icons/md";
import { getStaticBlogById } from "../../data/staticSiteContent";

type SingleBlogProps = {
  id: string;
};

export default function SingleBlogScreen(props: SingleBlogProps) {
  const navigate = useNavigate();
  const blog = useMemo(() => getStaticBlogById(props.id), [props.id]);

  const breadCrumbs = useMemo(() => {
    const base = [
      { title: <MdHomeFilled />, link: "/" },
      { title: "Blogs", link: "/blogs" },
    ];
    if (blog) {
      return [...base, { title: blog.title, link: "#" }];
    }
    return base;
  }, [blog]);

  useEffect(() => {
    if (!blog) {
      navigate("/blogs");
    }
  }, [blog, navigate]);

  if (!blog) {
    return null;
  }

  return (
    <div className="container mx-auto px-6 py-16">
      <Fade triggerOnce>
        <div className="flex flex-wrap items-center gap-1 mb-5 pt-14">
          {breadCrumbs.map((item, i) => {
            if (i < breadCrumbs.length - 1) {
              return (
                <span key={i} className="flex items-center gap-1">
                  <NavLink
                    to={item.link}
                    className={i === 0 ? "text-lg" : "text-sm"}
                  >
                    {item.title}
                  </NavLink>
                  <FaChevronRight fontSize="12px" />
                </span>
              );
            }
            return (
              <NavLink key={i} to={item.link} className="text-sm">
                {item.title}
              </NavLink>
            );
          })}
        </div>
        <img
          src={blog.image}
          alt=""
          className="w-full h-60 md:h-96 object-cover object-center rounded-xl mb-5"
        />
        <p className="text-3xl font-bold lg:text-4xl mb-7">{blog.title}</p>
        <div
          className="blog-content"
          dangerouslySetInnerHTML={{ __html: blog.description }}
        />
      </Fade>
    </div>
  );
}
